import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "row-top" }
const _hoisted_2 = { style: {"height":"91vh","width":"51.5vw","padding":"0rem 1rem 0rem 0rem"} }
const _hoisted_3 = ["src"]
const _hoisted_4 = { style: {"width":"20rem","height":"100%","padding-right":"1rem"} }
const _hoisted_5 = { class: "row gap-04 w-full" }
const _hoisted_6 = {
  style: {"height":"10rem"},
  class: "mtop-06"
}
const _hoisted_7 = {
  key: 0,
  class: "row"
}
const _hoisted_8 = { class: "mtop-15" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "mtop-20" }

import patientChange from "@/views/mainMenu/patientChange.vue"

import { ref, computed, onMounted, nextTick } from 'vue';
import { DateFormat } from '@/models/share.model';
import { format } from 'date-fns';
import officeapi from '@/api/officeapi';
import { useUiStore } from '@/stores/ui';
import PersonService from "@/services/PersonService";


export default /*@__PURE__*/_defineComponent({
  __name: 'taskNotesRename',
  props: {
  task: {
    type: Object,
    required: true,
  },
  tasks: {
    type: Array,
    required: false,
  },    
},
  emits: ['changed'],
  setup(__props, { emit: __emit }) {

const uiStore = useUiStore();

const props = __props

const isTaskFullyRenamed = computed(() => {
  if (!currTask.value) return false;
  if (currTask.value.taskStatus !== "Rename") return false;
  if (currTask.value.originalExpression === '') return false;
  if (!currTask.value.pwrPatient) return false;
  return true;
})

const localTasks = ref([...props.tasks])

async function integrateRenamedResultFile() {
  const taskId = currTask.value.taskId;
  const op = officeapi.integrateRenamedResultFile(taskId);
  emitChanged(op);
  await op;
  getNextRename();
}

function getNextRename() {
  const removedIndex = currentIndex.value
  localTasks.value.splice(removedIndex, 1)  
  if (localTasks.value.length === 0) {
    uiStore.setModalUiId("");
  } else if (removedIndex < localTasks.value.length) {
    currTask.value = localTasks.value[removedIndex]
    readTask()
  } else {
    currTask.value = localTasks.value[removedIndex - 1]
    readTask()
  }
}

const emits = __emit

const isInitializing = ref(true)

function emitChanged(promise) {
  if (isInitializing.value) return;
  emits('changed', promise);
}

const originalExprRef = ref(null)
const currTask = ref(null)

const localFileUrl = ref(null)
const localPdfUrl = ref(null)

async function getFile() {
  const mimeType = currTask.value.taskImportFile.mimeType;
  
  //Clear
  localFileUrl.value = null
  localPdfUrl.value = null
  //Check
  if (currTask.value.taskStatus !== 'Rename') {console.log("Error. Not a TaskImportFile"); return;}
  //API
  const taskId = currTask.value.taskId
  const respBlob = await officeapi.getTaskImportFileStream(taskId)
  //Fill
 // const myBlob = new Blob([respBlob])
  const myBlob= new Blob([respBlob], {type: mimeType})
  localFileUrl.value = window.URL.createObjectURL(myBlob)
  localPdfUrl.value = window.URL.createObjectURL(myBlob)
}

async function deleteTask() {
  const taskId = currTask.value.taskId;
  emitChanged(officeapi.validateTask(taskId));
  uiStore.setModalUiId("");
}


const isForIFrame = computed(() => {
  if (!currTask.value) return false;
  const mimeType = currTask.value.taskImportFile.mimeType;
  if (mimeType.startsWith("audio") || mimeType.startsWith("image")) return true;
  return ['application/pdf', 'text/plain'].includes(mimeType);
})

const currentIndex = computed(() => {
  if (!currTask.value) return -1;
  return localTasks.value.findIndex(t => t.taskId === currTask.value.taskId);
})

const hasPrevious = computed(() => {
  if (!currTask.value) return false;
  return currentIndex.value > 0
})

const hasNext = computed(() => {
  if (!currTask.value) return false;
  return currentIndex.value < localTasks.value.length - 1
})

function previousTask() {
  if (hasPrevious.value === true) {
    const prevTask = localTasks.value[currentIndex.value - 1]
    currTask.value = prevTask
    readTask()
  }  
}

function nextTask() {
  if (hasNext.value === true) {
    const nextTask = localTasks.value[currentIndex.value + 1]
    currTask.value = nextTask
    readTask()
  }  
}

function formatDateToISO(dateStr: string) {
  if (dateStr.length === 8) {
    const year = dateStr.substring(0, 4);
    const month = dateStr.substring(4, 6);
    const day = dateStr.substring(6, 8);
    return `${year}-${month}-${day}`;
  }
  return dateStr;
}

const FILE_PATTERNS = {
  // Laboratoires Réunis: 901234_1967110118695_2509240646_BAC_20250925_090404
  LR: /^\d+_(\d{13})_\d+_[A-Z]+_(\d{8})_\d+$/,
  // KetterThill: 1967110118695-20250924-253721402-LKT
  KT: /^(\d{13})-(\d{8})-\d+-[A-Z]+$/,
  // Bionext: 202509241644 BIO 2025-09-24 PAT 1967 11 01 186 95 - LASTNAME Firstname 0034858444
  BN: /^\d+ BIO (\d{4}-\d{2}-\d{2}) PAT (\d{4} \d{2} \d{2} \d{3} \d{2}) - .+$/,
  // LNS: 300231201-20260327-155200-1941042422692-CS_RCDS
  LNS: /^\d+-(\d{8})-\d{6}-(\d{13})-([A-Z_]+)$/,
  // CHEM:
  // 19301211_LAST_First Name_IRM crâne C-_CHEME000000013337979
  // 19630524_LAST_First Name_Colofibroscopie_682986 20260720105112
  // 19580329_LAST_First Name_Gastroscopie  Midazolam _AGFA5659892 20260720110810
  // 19811102_LAST_First Name_Mikrobiologie_5291888
  CHEM: /^(\d{8})_[^_]+_[^_]+_([^_]+)_(?:CHEM.+|.+ (\d{14})|\d+)$/,
  // CHDN: P00127351-20260617-070000-1978120222612-A007992706-RADIO
  CHDN: /^P\d+-(\d{8})-\d{6}-(\d{13})-A\d+-([A-Z]+)$/,
};

const PARSERS = [
  { match: "LR",   re: FILE_PATTERNS.LR,   extract: (m: RegExpMatchArray) => ({ personId: m[1], date: formatDateToISO(m[2]), text: "Bio" }) },
  { match: "KT",   re: FILE_PATTERNS.KT,   extract: (m: RegExpMatchArray) => ({ personId: m[1], date: formatDateToISO(m[2]), text: "Bio" }) },
  { match: "BN",   re: FILE_PATTERNS.BN,   extract: (m: RegExpMatchArray) => ({ personId: m[2].replace(/ /g, ''), date: m[1], text: "Bio" }) },
  { match: "LNS",  re: FILE_PATTERNS.LNS,  extract: (m: RegExpMatchArray) => ({ personId: m[2], date: formatDateToISO(m[1]), text: "LNS" }) },
  { match: "CHEM", re: FILE_PATTERNS.CHEM, extract: (m: RegExpMatchArray) => ({ personId: m[1], date: m[3] ? formatDateToISO(m[3].substring(0, 8)) : null as string | null, text: m[2].trim() }) },
  { match: "CHDN", re: FILE_PATTERNS.CHDN, extract: (m: RegExpMatchArray) => ({ personId: m[2], date: formatDateToISO(m[1]), text: m[3] }) },
];

function parseFilename(filename: string) {
  for (const { match, re, extract } of PARSERS) {
    const m = filename.match(re);
    if (m) return { match, ...extract(m) };
  }
  return null;
}

async function readTask() {
  if (!currTask.value) return;
  //Old values
  oldOriginalExpression.value = currTask.value.originalExpression;
  oldResultDate.value = currTask.value.resultDate || new Date();
  oldPwrPatient.value = currTask.value.pwrPatient;
  initialPatientSearch.value = "";
  //New values
  originalExpressionInput.value = currTask.value.originalExpression;
  pwrPatient.value = currTask.value.pwrPatient;
  //Try parsing
  const fileName = currTask.value.taskImportFile.fileName;
  const parsedData = parseFilename(fileName);
  if (parsedData) {
    const { personId, date, text } = parsedData;
    if (!currTask.value.originalExpression && !currTask.value.pwrPatient && date) {
      updateResultDate(date);
      oldResultDate.value = new Date(date);
    }    
    if (!currTask.value.originalExpression) {
      originalExpressionInput.value = text || "";
      updateOriginalExpressionInput()
    }
    if (!currTask.value.pwrPatient) {
      const pwrFoundPatient = await addPwrPatientFromCnsNumberToTask(personId);
      if (pwrFoundPatient) {
        pwrPatient.value = pwrFoundPatient;
        oldPwrPatient.value = pwrFoundPatient;
        currTask.value.pwrPatient = pwrFoundPatient;
      } else {
        nextTick(() => {  //Next tick is needed in order to systematically trigger the watcher in patientChange
          initialPatientSearch.value = personId || "";
        });
      }
    }
  }
  //Get file
  getFile()
}

async function addPwrPatientFromCnsNumberToTask(cnsNumber) {
  const taskId = currTask.value.taskId
  return await officeapi.addPwrPatientFromCnsNumberToTask(taskId, cnsNumber)
}

const oldOriginalExpression = ref(null)
const originalExpressionInput = ref(null)
async function updateOriginalExpressionInput() {
  if (!currTask.value) return;
  const taskId = currTask.value.taskId
  const oldContent = oldOriginalExpression.value
  const newContent = originalExpressionInput.value
  if (oldContent === newContent) return;
  oldOriginalExpression.value = newContent
  currTask.value.originalExpression = newContent
  emitChanged(officeapi.updateImportFileOriginalExpression(taskId, newContent));
}

const oldResultDate = ref(null);

async function updateResultDate(newDate) {
  const taskId = currTask.value.taskId
  emitChanged(officeapi.updateImportFileResultDate(taskId, newDate));
}

async function updateResultDateFromPicker(newDate) {
  const actDateIso = format(new Date(newDate), DateFormat.ISO_SMALL); //Conversion to avoid unwanted TZ change
  updateResultDate(actDateIso);
}

const oldPwrPatient = ref(null);
const pwrPatient = ref(null);
const initialPatientSearch = ref("");
async function changePatientFct(newContent) {
  pwrPatient.value = newContent
  if (!currTask.value) return;
  const taskId = currTask.value.taskId
  const oldContent = oldPwrPatient.value
  originalExprRef.value.$el.focus()
  if (oldContent?.personWithRoleId === newContent?.patientId) return;
  oldPwrPatient.value = newContent
  currTask.value.pwrPatient = newContent
  emitChanged(officeapi.updateImportPwrPatient(taskId, newContent?.patientId || null));
}

onMounted(async () => {
  currTask.value = props.task
  await readTask()
  isInitializing.value = false
})


return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_button_group = _resolveComponent("button-group")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_inputLineNew2 = _resolveComponent("inputLineNew2")!
  const _component_inputBox = _resolveComponent("inputBox")!
  const _component_esInputDateTime = _resolveComponent("esInputDateTime")!

  return (_openBlock(), _createElementBlock("div", {
    class: "bg-modal w-maxC",
    onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (!isForIFrame.value)
          ? (_openBlock(), _createBlock(_component_text_item, {
              key: 0,
              txt: "No preview",
              styles: "main-m",
              class: "mtop-04 mleft-04"
            }))
          : (!localFileUrl.value)
            ? (_openBlock(), _createBlock(_component_text_item, {
                key: 1,
                txt: "Loading ...",
                styles: "main-m",
                class: "mtop-04 mleft-04"
              }))
            : (_openBlock(), _createElementBlock("iframe", {
                key: 2,
                src: localPdfUrl.value,
                scrolling: "yes",
                frameborder: "1",
                style: {"height":"91vh","width":"50vw"}
              }, null, 8, _hoisted_3))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_button_group, {
            styles: "pad-l",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (deleteTask())),
            style: {"margin-left":"-0.5rem"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_svg_item, {
                icon: "trash",
                styles: "main-l"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_button_group, {
            styles: hasPrevious.value ? 'border-h pad-s' : 'border-l pad-s',
            class: "psides-10 mleft-10",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (previousTask()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_text_item, {
                txt: "<",
                styles: hasPrevious.value ? 'font-mBold' : 'font-mBold main-l'
              }, null, 8, ["styles"])
            ]),
            _: 1
          }, 8, ["styles"]),
          _createVNode(_component_button_group, {
            styles: hasNext.value ? 'border-h pad-s' : 'border-l pad-s',
            class: "psides-10",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (nextTask()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_text_item, {
                txt: ">",
                styles: hasNext.value ? 'font-mBold' : 'font-mBold main-l'
              }, null, 8, ["styles"])
            ]),
            _: 1
          }, 8, ["styles"]),
          (isTaskFullyRenamed.value)
            ? (_openBlock(), _createBlock(_component_button_group, {
                key: 0,
                styles: "border-m pad-s",
                class: "psides-06 mleft-auto",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (integrateRenamedResultFile()))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_text_item, {
                    txt: "Intégrer",
                    styles: "font-mBold"
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_text_item, {
            class: "mleft-02 linebreak cursor-sel",
            txt: currTask.value?.taskNotes[0]?.noteContent,
            styles: "font-m main-m"
          }, null, 8, ["txt"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_text_item, {
            txt: "Patient",
            styles: "main-m"
          }),
          (pwrPatient.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_text_item, {
                  class: "mleft-02",
                  txt: _unref(PersonService).formatName(pwrPatient.value.lastName, pwrPatient.value.firstName),
                  styles: "font-mBold main-h"
                }, null, 8, ["txt"]),
                _createVNode(_component_buttonGroup, {
                  class: "mleft-10",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (changePatientFct(null)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_svg_item, {
                      icon: "x",
                      styles: "size-m main-l",
                      style: {"margin-top":"-0.3rem"}
                    })
                  ]),
                  _: 1
                })
              ]))
            : (_openBlock(), _createBlock(patientChange, {
                key: 1,
                initialPatientSearch: initialPatientSearch.value,
                onSelectedPatient: changePatientFct
              }, null, 8, ["initialPatientSearch"]))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_text_item, {
              txt: "Nom du résultat",
              styles: "main-m"
            }),
            _createVNode(_component_text_item, {
              class: "mleft-10",
              txt: "(p.ex. scanner thoracique)",
              styles: "main-m"
            })
          ]),
          _createVNode(_component_inputBox, { class: "row-stretch mtop-03" }, {
            default: _withCtx(() => [
              _createVNode(_component_inputLineNew2, {
                ref_key: "originalExprRef",
                ref: originalExprRef,
                modelValue: originalExpressionInput.value,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((originalExpressionInput).value = $event)),
                onBlur: _cache[6] || (_cache[6] = ($event: any) => (updateOriginalExpressionInput()))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_text_item, {
            txt: "Date du résultat",
            styles: "main-m"
          }),
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "mtop-04" }, null, -1)),
          _createVNode(_component_esInputDateTime, {
            inline: "",
            dateTimeValue: new Date(oldResultDate.value),
            dateFormat: _unref(DateFormat).DATEPICKER,
            range: false,
            withTime: false,
            onUpdateDateTime: updateResultDateFromPicker
          }, null, 8, ["dateTimeValue", "dateFormat"])
        ])
      ])
    ])
  ]))
}
}

})